import _ from 'lodash'
import { ValidityDeterminate } from '@fusion-advantage/backcompat'
import { UlcerReviewConcept, ulcerReviewItemIsValid, newUlcerReviewItem, ExecutableCalc, CalcType, ExecutableCalcCalculateFunction, ExecutableCalcCalculateOk, CalcRuntimeError, cidForDirItemId } from '@fusion-advantage/formlib'
import { Result, ok } from 'neverthrow'
import { FormRootState } from '../../redux/formStore'
import { createSelector } from '@reduxjs/toolkit'

//
//
// ULCER
//

/* this might be used later
export const ulcerValueListItemCalc = new ValueCalc(
	"c627578f68846ef166c",
	[UlcerReviewConcept.cid],
	(ctx) => {
		const statusValue = ctx.statusValue(UlcerReviewConcept.cid)
		const { models } = ulcerReviewParse(statusValue)

		if(models && models?.length > 0) {
			return {
				value: true,
				subconceptCid: cidForDirValue("Ulcer")
			}
		}

		return {
			value: false,
			subconceptCid: cidForDirValue("Ulcer")
		}
	},
	{
		global: true
	}
)
*/

export const createUlcerValidationCalc = (getState: () => FormRootState): ExecutableCalc => {
	const selectCalculateFn = createSelector(
		(state: FormRootState) => state.formModel.ulcerReview,
		(models): ExecutableCalcCalculateFunction => {
			return (ctx): Result<ExecutableCalcCalculateOk, CalcRuntimeError> => {
				const nonEmptyModels = models.filter(x => !_.isEqual(newUlcerReviewItem(), x))
				const uniqueModels = new Set([...nonEmptyModels.map(item => JSON.stringify(item))])

				// non-empty models
				const nonEmptyModelsAreValid = nonEmptyModels.every(ulcerReviewItemIsValid)
				
				if(!nonEmptyModelsAreValid) {
					return ok({
						calcType: CalcType.Validation,
						returnValue: {
							determinate: ValidityDeterminate.Invalid,
							message: 'Ulcer Review table contains invalid entries. All fields must be filled out for each entry',
						}
					})
				}

				if (uniqueModels.size !== nonEmptyModels.length) {
					return ok({
						calcType: CalcType.Validation,
						returnValue: {
							determinate: ValidityDeterminate.Invalid,
							message: 'Duplicate entry in Ulcer Review table',
						}
					})
				}

				return ok({
					calcType: CalcType.Validation,
					returnValue: { determinate: ValidityDeterminate.Valid }
				})
			}
		},
	)
	return new ExecutableCalc({
		calcType: CalcType.Validation,
		outputCid: UlcerReviewConcept.cid,
		inputCids: [UlcerReviewConcept.cid],
		selectCalculate: () => selectCalculateFn(getState())
	})
}

export const createUlcerFollowUpPcpValueCalc = (getState: () => FormRootState) => {
	const selectCalculateFn = createSelector(
		(state: FormRootState) => state.formModel.ulcerReview,
		(ulcerItems): ExecutableCalcCalculateFunction => {
			return (ctx): Result<ExecutableCalcCalculateOk, CalcRuntimeError> => {
				const nonEmptyUlcerItems = ulcerItems.filter(x => !_.isEqual(newUlcerReviewItem(), x) && ulcerReviewItemIsValid(x))

				if(nonEmptyUlcerItems.length > 0) {
					return ok({ calcType: CalcType.Value, returnValue: [{ value: true }] })
				}

				return ok({ calcType: CalcType.Value, returnValue: [{ value: null }] })
			}
		}
	)
	const inputCids = [
		UlcerReviewConcept.cid,
	]
	return new ExecutableCalc({
		calcType: CalcType.Value,
		outputCid: cidForDirItemId(1361),
		inputCids,
		selectCalculate: () => selectCalculateFn(getState())
	})
}